import tinycolor from 'tinycolor2';
export const color = {
    uiLightPrimary: '#FFFFFF',
    uiLightStain: '#F7F9FA',
    uiLightNeutral: '#F2F3F3',
    uiLightSecondary: '#CDD0D1',
    uiDarkPrimary: '#03121A',
    uiDarkStain: '#1C2930',
    uiDarkNeutral: '#354148',
    uiDarkSecondary: '#687176',
    uiBluePrimary: '#0194f3',
    uiBlueSecondary: '#007CE8',
    uiBlueDark: '#0264C8',
    uiBlueLight: '#ECF8FF',
    uiOrangePrimary: '#FF5E1F',
    uiOrangeSecondary: '#DF440F',
    uiOrangeDark: '#BF1D00',
    uiOrangeLight: '#FFF4EF',
    uiGreenPrimary: '#0BC175',
    uiGreenSecondary: '#05A569',
    uiGreenDark: '#00875A',
    uiGreenLight: '#E8FEF5',
    uiRedPrimary: '#F4555A',
    uiRedSecondary: '#EC3A3E',
    uiRedDark: '#E7090E',
    uiRedLight: '#FCE3E4',
    uiYellowPrimary: '#FFDC00',
    uiYellowSecondary: '#D99800',
    uiYellowDark: '#B15400',
    uiYellowLight: '#FFFAD9',
    brandGodwitBlue: '#1BA0E2',
    brandHighAltitude: '#30C5F7',
    brandGoodNight: '#235D9F',
    brandSpeedLine: '#FCA000',
    brandCoralReef: '#FF6D6A',
    brandSignalPulse: '#F0298A',
    brandBusinessSuit: '#073E68',
    brandFieldTrip: '#20BF55',
    brandRipeCarrot: '#F86F09',
    brandFuelTank: '#087E8B',
    brandTerminalLounge: '#6DD3CE',
    brandFuchsiaFusion: '#931682',
    get overlay() {
        return this.uiDarkPrimary;
    },
};
export const spacing = {
    xxs: 4,
    xs: 8,
    s: 12,
    m: 16,
    ml: 20,
    l: 24,
    xl: 32,
    xxl: 40,
    xxxl: 48,
    xxxxl: 56,
};
export const animation = {
    timing: {
        instant: 200,
        normal: 300,
        slow: 500,
    },
};
export const fontSize = {
    gigantic: 48,
    huge: 32,
    big: 24,
    large: 20,
    medium: 16,
    small: 14,
    tiny: 12,
    micro: 11,
};
export const border = {
    width: {
        thin: 0.5,
        thick: 1,
        bold: 2,
    },
    radius: {
        default: 6,
        rounded: '50%',
    },
};
// Use Closure to generate new function
function makeOpacityGetter(opacityPercentage) {
    return function getOpacity(color) {
        if (!color)
            return opacityPercentage;
        const formattedColor = tinycolor(color);
        formattedColor.setAlpha(opacityPercentage);
        return formattedColor.toHex8String();
    };
}
export const opacity = {
    opaque: makeOpacityGetter(0.8),
    obscure: makeOpacityGetter(0.65),
    translucent: makeOpacityGetter(0.5),
    washedOut: makeOpacityGetter(0.4),
    seeThrough: makeOpacityGetter(0.2),
    clear: makeOpacityGetter(0.15),
};
